module.exports = __webpack_public_path__ + "assets/img/20220512-1.9e4a6f58.png";